module.exports = __webpack_public_path__ + "d3c5506ece5f0dd3dbaa0a62bf841ac0.png";